export default __webpack_public_path__ + "static/media/OrderFlow.f8d2d3fa4536c94789dd9e9a8968342d.webp";